import React from 'react'
import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faArrowRotateRight } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useTranslationRankmi } from 'helpers/translations.helper'
import AiGradientDefs from './AiGradientDefs'
import { AI_ERROR_MODAL_WIDTH } from './aiEvaluationTokens'
import {
  AI_EVALUATION_MODAL_WRAP,
  ErrorContentArea,
  ErrorDescription,
  ErrorFooter,
  ErrorLayout,
} from './AiEvaluationModal.styled'
import {
  FooterActions,
  FooterCancelButton,
  FooterRegenerateButton,
  FooterRegenerateIcon,
  FooterRegenerateLabel,
} from './EvaluationPreview.styled'

interface Props {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
}

const RegenerateAllConfirmModal: React.FC<Props> = ({
  visible,
  onCancel,
  onConfirm,
}) => {
  const tConfirm = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.regenerateAllConfirm',
  })
  const tPreview = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.previewModal',
  })

  return (
    <>
      <AiGradientDefs />
      <Modal
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={AI_ERROR_MODAL_WIDTH}
        title={tConfirm('title')}
        closeIcon={<FontAwesomeIcon icon={faTimes as IconProp} />}
        destroyOnClose
        zIndex={1100}
        wrapClassName={`${AI_EVALUATION_MODAL_WRAP} ai-evaluation-modal-wrap--error`}
      >
        <ErrorLayout>
          <ErrorContentArea>
            <ErrorDescription>{tConfirm('description')}</ErrorDescription>
          </ErrorContentArea>

          <ErrorFooter>
            <FooterActions>
              <FooterCancelButton
                type="button"
                data-test-id="button-ai-evaluation-regenerate-all-cancel"
                onClick={onCancel}
              >
                {tPreview('cancel')}
              </FooterCancelButton>
              <FooterRegenerateButton
                type="button"
                data-test-id="button-ai-evaluation-regenerate-all-confirm"
                onClick={onConfirm}
              >
                <FooterRegenerateIcon icon={faArrowRotateRight} aria-hidden />
                <FooterRegenerateLabel>
                  {tConfirm('confirm')}
                </FooterRegenerateLabel>
              </FooterRegenerateButton>
            </FooterActions>
          </ErrorFooter>
        </ErrorLayout>
      </Modal>
    </>
  )
}

export default RegenerateAllConfirmModal
